// src/pages/Contact/Contact.jsx
import React from 'react';
import Can from './Can';

function Contact() {
  return <Can />;
}

export default Contact;